class ExternalProductGallery extends HTMLElement {
  connectedCallback() {
    this.hydrateFromJson();
    this.bind();
  }

  hydrateFromJson() {
    const script = this.querySelector('[data-external-product-gallery-json]');
    if (!script) {
      return;
    }

    const images = this.parseImages(script.textContent);
    if (!Array.isArray(images) || images.length === 0) {
      return;
    }

    const main = this.querySelector('.external-product-gallery__main');
    const thumbs = this.querySelector('.external-product-gallery__thumbs');
    if (!main || !thumbs) {
      return;
    }

    main.replaceChildren(...images.map((image, index) => this.createSlide(image, index)));
    thumbs.replaceChildren(...images.map((image, index) => this.createThumb(image, index)));
  }

  parseImages(json) {
    try {
      const parsed = JSON.parse(json);
      return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
    } catch (error) {
      return [];
    }
  }

  bind() {
    this.slides = Array.from(this.querySelectorAll('[data-external-product-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-external-product-thumb]'));

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.activate(Number(thumb.dataset.slideIndex || 0));
      });
    });
  }

  createSlide(image, index) {
    const slide = document.createElement('div');
    slide.className = `external-product-gallery__slide${index === 0 ? ' is-active' : ''}`;
    slide.dataset.externalProductSlide = '';
    slide.dataset.slideIndex = String(index);
    slide.append(this.createPicture(image, 'external-product-gallery__image', index === 0 ? 'eager' : 'lazy'));

    return slide;
  }

  createThumb(image, index) {
    const thumb = document.createElement('button');
    thumb.className = `external-product-gallery__thumb${index === 0 ? ' is-active' : ''}`;
    thumb.type = 'button';
    thumb.dataset.externalProductThumb = '';
    thumb.dataset.slideIndex = String(index);
    thumb.setAttribute('aria-label', `Show image ${index + 1}`);
    thumb.append(this.createPicture(image, 'external-product-gallery__thumb-image', 'lazy'));

    return thumb;
  }

  createPicture(image, className, loading) {
    const picture = document.createElement('picture');
    const webp = image?.sources?.webp || {};
    const jpeg = image?.sources?.jpeg || {};

    if (webp.medium || webp.large || webp.xlarge) {
      const source = document.createElement('source');
      source.type = 'image/webp';
      source.srcset = this.srcset(webp);
      source.sizes = className.includes('thumb') ? '96px' : '(min-width: 990px) 60vw, 100vw';
      picture.append(source);
    }

    const img = document.createElement('img');
    img.className = className;
    img.src = jpeg.large || image?.original_url || '';
    img.srcset = this.srcset(jpeg);
    img.sizes = className.includes('thumb') ? '96px' : '(min-width: 990px) 60vw, 100vw';
    img.alt = image?.alt || '';
    img.width = image?.width || 1500;
    img.height = image?.height || img.width;
    img.loading = loading;
    picture.append(img);

    return picture;
  }

  srcset(sources) {
    return [
      sources.medium ? `${sources.medium} 400w` : '',
      sources.large ? `${sources.large} 1500w` : '',
      sources.xlarge ? `${sources.xlarge} 2500w` : '',
    ].filter(Boolean).join(', ');
  }

  activate(index) {
    this.slides.forEach((slide) => {
      slide.classList.toggle('is-active', Number(slide.dataset.slideIndex || 0) === index);
    });

    this.thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', Number(thumb.dataset.slideIndex || 0) === index);
    });
  }
}

if (!customElements.get('external-product-gallery')) {
  customElements.define('external-product-gallery', ExternalProductGallery);
}
